import {ControlGroupCollection} from "../collections/ControlGroups";
import {ControlCollection} from "../collections/Controls";
import {BaseAppView, BaseAppViewOptions} from "../../_BaseAppViews";
import {ModuleCollection} from "../../../collections/Modules";
import {Trigger} from "../models/Trigger";
import {TriggerCollection} from "../collections/Triggers";
import {TriggerViewManager} from "./edit_control/triggers/TriggerViewManager";
import {GenericDeleteModal} from "../../../views/modals/GenericDeleteModal";
import {ConditionComponentCollection} from "../collections/ConditionComponents";
import {ConditionCollection} from "../collections/Conditions";
import {ChannelTagCollection} from "../../../collections/ChannelTags";
import {TriggerChannelCollection} from "../collections/TriggerChannels";
import {OutputCollection} from "../collections/Outputs";
import * as Backbone from "backbone";
import {ControlChannelCollection} from "../collections/ControlChannels";
import {BaseModifyModalView, BaseModifyModalViewOptions} from "../../../views/modals/_BaseModifyModal";


/* The basic view for the controls app */
export interface BaseControlAppViewOptions extends BaseAppViewOptions {
    controlGroupCollection: ControlGroupCollection,
    moduleCollections: {[key: number]: ModuleCollection};
    channelTagCollections: {[key: number]: ChannelTagCollection};
    conditionComponentCollections: {[key: number]: ConditionComponentCollection};
    triggerCollections: {[key: number]: TriggerCollection};
    outputCollections: {[key: number]: OutputCollection};
    controlChannelCollections: {[key: number]: ControlChannelCollection};
    conditionCollections: {[key: number]: ConditionCollection};
    controlCollection: ControlCollection,
    triggerChannelCollection: TriggerChannelCollection,
    controlGroupId: number,
}

export interface ControlNavViewOptions extends BaseControlAppViewOptions {
    isGrouped: boolean
}

export interface BaseControlModalViewOptions extends BaseControlAppViewOptions, BaseModifyModalViewOptions {}

export class BaseControlAppView extends BaseAppView {

    public options: BaseControlAppViewOptions;

    constructor(options: BaseControlAppViewOptions){
        super(options);
    }

}

export class BaseControlModalView extends BaseModifyModalView {

    public options: BaseControlModalViewOptions;

    constructor(options: BaseControlModalViewOptions){
        super(options);
    }

}


/* The basic view for triggers within the ModifyTriggerModal */
export interface BaseModifyControlTriggerModalOptions extends BaseControlAppViewOptions {
    triggerCollection: TriggerCollection;
    moduleCollections: {[key: number]: ModuleCollection};
    controlTrigger: Trigger;
    parentView: any;
    lastSelectedInstallId: number
}
export class BaseModifyControlTriggerModal extends BaseControlAppView {

    public options: BaseModifyControlTriggerModalOptions;

    constructor(options: BaseModifyControlTriggerModalOptions){
        super(options);
    }

    prepareForSaving() {}
    getChannelDifference() {return [];}
    show() {}
}


/* The basic view for triggers */
export interface BaseTriggerViewOptions extends BaseControlAppViewOptions {
    triggerCollection: TriggerCollection;
    moduleCollections: {[key: number]: ModuleCollection};
    manager: TriggerViewManager
    controlTrigger: Trigger,
    editable: boolean,
    cssClass?: string

}
export class BaseTriggerView extends BaseControlAppView {

    public options: BaseTriggerViewOptions;

    constructor(options: BaseTriggerViewOptions){
        super(options);
    }

    handleRemoveClick() {
        var view = new GenericDeleteModal({
            name: this.options.controlTrigger.get('name'),
            type: this.options.controlTrigger.getDisplayType(),
            func: () => {
                this.remove();
                return $.when(this.options.controlTrigger.destroy()).done(() => {
                    Backbone.history.loadUrl();
                });
            }
        });

        $('.modals').append(view.render().el);
        view.show();
    }

    handleEditClick() {
        this.options.manager.createModifyTriggerModal(this.options.controlTrigger);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/controls/views/_BaseControlAppViews.ts